import React, { FunctionComponent } from "react";
import { Theme, makeStyles, Typography, PropTypes } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  heading: {
    fontSize: ({ small }: IContentTextProps) => (small ? 16 : 18),
    fontWeight: ({ light, bold }: IContentTextProps) => (light ? 300 : bold ? 700 : 400),
    width: "100%",
  },
}));

interface IContentTextProps {
  light?: boolean;
  bold?: boolean;
  small?: boolean;
  align?: PropTypes.Alignment;
}

export const ContentText: FunctionComponent<IContentTextProps> = (props) => {
  const { children, align } = props;
  const classes = useStyles(props);
  return (
    <Typography className={classes.heading} align={align ?? "left"}>
      {children}
    </Typography>
  );
};
